// extracted by mini-css-extract-plugin
module.exports = {"itProductBlock":"page_itProductBlock__SY1Ip","main":"page_main__GlU4n","white-block":"page_white-block__L9CyP"};